/**
 * External dependencies
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM, { Container } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import ReactGA from 'react-ga4';

/**
 * Internal dependencies
 */
import './env.ts';
import router from 'routes';
import StripeProvider from 'components/stripe/stripe-provider';
import { AuthProvider } from 'data/oauth/use-oauth';
import I18NController from 'lib/i18n';
import { applyRedesignTheme } from 'design-system';

/**
 * Style dependencies
 */
import './style.scss';

let app;

// @ts-expect-error This is injected in dev mode.
if ( module.hot ) {
	// @ts-expect-error This is injected in dev mode.
	module.hot.accept();
}

// @ts-expect-error This is defined here.
if ( window._hpp_app !== undefined ) {
	// @ts-expect-error This is defined here.
	app = window._hpp_app;
} else {
	app = {
		queryClient: new QueryClient(),
		container: ReactDOM.createRoot( document.getElementById( 'root' ) as Container ),
	};

	// @ts-expect-error This is defined here.
	window._hpp_app = app;

	ReactGA.initialize( 'G-7EWDE597ZB' );
}

// Redesign theme (WPDS tokens + WP Cloud overrides) — no-op unless the `wpcloud-redesign` flag is on.
applyRedesignTheme();

app.container.render(
	<React.StrictMode>
		<AuthProvider>
			<QueryClientProvider client={ app.queryClient }>
				<StripeProvider>
					<I18NController />
					<RouterProvider router={ router } />
				</StripeProvider>
			</QueryClientProvider>
		</AuthProvider>
	</React.StrictMode>
);
